/**
 * Table of Contents - EaseCloud Brand
 * Automatically generates TOC from article headings
 */
(function () {
  var tocList = document.getElementById("toc-list");
  var tocNav = document.getElementById("toc-nav");
  var tocToggle = document.getElementById("toc-toggle");
  var tocSidebar = document.getElementById("easecloud-toc");

  if (!tocList) return;

  // Find all headings in the article
  var article = document.querySelector(".gh-content");
  if (!article) return;

  var headings = article.querySelectorAll("h2");

  if (headings.length === 0) {
    // No headings, hide TOC
    if (tocSidebar) tocSidebar.style.display = "none";
    return;
  }

  // Generate TOC items
  var tocItems = [];
  headings.forEach(function (heading, index) {
    // Generate unique ID for heading
    var id = heading.id || "heading-" + index;
    if (!heading.id) heading.id = id;

    var level = heading.tagName.toLowerCase().replace("h", "");
    var text = heading.textContent.trim();

    var li = document.createElement("li");
    li.className = "easecloud-toc-item";

    var link = document.createElement("a");
    link.className = "easecloud-toc-link";
    link.href = "#" + id;
    link.textContent = text;
    link.setAttribute("data-level", level);
    link.setAttribute("data-target", id);

    li.appendChild(link);
    tocList.appendChild(li);
    tocItems.push({ link: link, id: id });
  });

  // Smooth scroll on click
  tocList.addEventListener("click", function (e) {
    if (e.target.classList.contains("easecloud-toc-link")) {
      e.preventDefault();
      var targetId = e.target.getAttribute("data-target");
      var target = document.getElementById(targetId);
      if (target) {
        var offset = 120; // Account for sticky header + spacing
        var targetPosition =
          target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });
      }
    }
  });

  // Highlight active section on scroll
  function updateActiveSection() {
    var scrollPosition = window.pageYOffset + 180;

    var activeHeading = null;

    headings.forEach(function (heading) {
      if (heading.offsetTop <= scrollPosition) {
        activeHeading = heading;
      }
    });

    // Remove all active classes
    document
      .querySelectorAll(".easecloud-toc-link.active")
      .forEach(function (link) {
        link.classList.remove("active");
      });

    // Add active class to current section
    if (activeHeading) {
      var activeId = activeHeading.id;
      var activeLink = document.querySelector(
        '.easecloud-toc-link[data-target="' + activeId + '"]',
      );
      if (activeLink) {
        activeLink.classList.add("active");

        // Scroll TOC to keep active item visible
        if (tocNav && window.innerWidth >= 1200) {
          var linkTop = activeLink.offsetTop;
          var navHeight = tocNav.offsetHeight;
          var linkHeight = activeLink.offsetHeight;

          if (linkTop < tocNav.scrollTop) {
            tocNav.scrollTop = linkTop - 10;
          } else if (linkTop + linkHeight > tocNav.scrollTop + navHeight) {
            tocNav.scrollTop = linkTop + linkHeight - navHeight + 10;
          }
        }
      }
    }
  }

  // Throttled scroll handler
  var ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateActiveSection();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Mobile toggle
  if (tocToggle && tocNav) {
    // Start collapsed on mobile
    if (window.innerWidth < 1200) {
      tocNav.classList.add("collapsed");
      tocToggle.classList.add("collapsed");
    }

    tocToggle.addEventListener("click", function () {
      tocNav.classList.toggle("collapsed");
      tocToggle.classList.toggle("collapsed");
    });
  }

  // Initial active section
  updateActiveSection();
})();
